import { render, staticRenderFns } from "./matrixCreate.vue?vue&type=template&id=4fcf7197&"
import script from "./matrixCreate.vue?vue&type=script&lang=js&"
export * from "./matrixCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports